import { FC } from 'react'

import { ConditionRenderProps } from './ConditionRender.props'

const ConditionRender: FC<ConditionRenderProps> = ({ condition, component, secondComponent = null }) =>
  condition ? component : secondComponent

export default ConditionRender
